"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItsHammerTimeAbilityHandler = exports.ItsHammerTimeActorAbilityFactory = exports.ItsHammerTimeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ItsHammerTimeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ItsHammerTime;
        this.__typeName = "ItsHammerTime";
    }
}
exports.ItsHammerTimeAbilityArgs = ItsHammerTimeAbilityArgs;
let ItsHammerTimeActorAbilityFactory = class ItsHammerTimeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ItsHammerTime", "AllEnemies", 0);
    }
};
ItsHammerTimeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ItsHammerTime")
], ItsHammerTimeActorAbilityFactory);
exports.ItsHammerTimeActorAbilityFactory = ItsHammerTimeActorAbilityFactory;
let ItsHammerTimeAbilityHandler = class ItsHammerTimeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            projectiles: enemies.map(enemyId => ({
                targetId: enemyId,
                jitter: (0, Random_1.random)(25, 75),
                type: "SmallBlueSpark",
                path: (0, Random_1.randomElement)(["line", "arc"]),
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Holy", 50)
                ],
            }))
        });
    }
};
ItsHammerTimeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ItsHammerTime)
], ItsHammerTimeAbilityHandler);
exports.ItsHammerTimeAbilityHandler = ItsHammerTimeAbilityHandler;
